// TODO: Query this from referral /tableData endpoint

export const referralTableDataEnums = {
  closeReasons: {
    ADMIN_CANCEL: "admin-cancel",
    COMPLETED: "completed",
    DECLINED: "declined",
    EXPIRED: "expired",
    MEMBER_CANCEL: "member-cancel",
    PROVIDER_CANCEL: "provider-cancel",
    TRANSFERRED: "transferred",
    CLAIMED: "claimed",
    ARCHIVED: "archived",
  },
  referralStatuses: {
    ACTIVE: "active",
    NEW: "new",
    CLOSED: "closed",
  },
  sessionStatuses: {
    CANCELLED: "cancelled",
    COMPLETED: "completed",
    NO_SHOW: "no-show",
    SCHEDULED: "scheduled",
  },
  sessionTypes: {
    IN_PERSON: "in-person",
    PHONE: "phone",
    TELEHEALTH: "telehealth",
  },
  subCategories: {
    ACADEMIC_ISSUES: "academic-issues",
    ALCOHOL: "alcohol",
    ANXIETY: "anxiety",
    AUTISM: "autism",
    CONCIERGE: "concierge",
    CRISIS_RESPONSE: "crisis-response",
    CRITICAL_INCIDENT: "critical-incident",
    DEPRESSION: "depression",
    DISABILITY_MANAGEMENT: "disability-management",
    DRUGS: "drugs",
    EMOTIONAL: "emotional",
    FACILITY_REFERRAL: "facility-referral",
    FAMILY: "family",
    FITNESS_FOR_DUTY_FFD: "fitness-for-duty-ffd",
    GRIEF_AND_LOSS: "grief-and-loss",
    HR_CALLING_FOR_MEMBER: "hr-calling-for-member",
    INFORMAL_CONSULT: "informal-consult",
    IN_PERSON: "in-person",
    OCCUPATIONAL: "occupational",
    RELATIONSHIP: "relationship",
    STANDARD: "standard",
    STRESS: "stress",
    TOBACCO_CESSATION: "tobacco-cessation",
    TRAUMA: "trauma",
    VIRTUAL: "virtual",
  },
  treatmentCodes: {
    ET_CLIN: "et_clin",
    ET_COMM: "et_comm",
    ET_INDA: "et_inda",
    ET_INMH: "et_inmh",
    ET_MYHELPD: "et_myhelpd",
    ET_OUTDA: "et_outda",
    ET_OUTMH: "et_outmh",
  },
}
